
export const SET_IMPORT_TABLE = "SET_IMPORT_TABLE";

export const IMPORT_LIST_SUCCESS = "IMPORT_LIST_SUCCESS";
export const IMPORT_LIST_FAILED = "IMPORT_LIST_FAILED";
